import CommonUiModel from "../common/commonUiModel";

const Chemistry = new CommonUiModel({
  title: "Chemistry",
  columns: [
    {
      field: 'ChemistryId',
      gridLabel: 'Chemistry Id',
      type: 'number',
      width: 100,
      label: null
    },
    {
      field: "ChemistryName",
      label: "Chemistry Name",
      required: true,
      max: 100
    },
    {
      field: "Description",
      multiline: true,
      max: 2000
    },
    {
      field: "Notes",
      multiline: true,
      max: 2000
    },
    {
      field: "ChemistryRegion",
      label: "Region",
      lookup: 'Region',
      type: "autocomplete",
      width: 350,
      sortable: false
    }
  ]
});

export default Chemistry;
